<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :label="language['gift_user_app']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="app">
              <a-select v-model="model.app" :placeholder="language['common.pleaseChoose']+language['gift_app_no']" >
                <a-select-option  v-for="(value, key) in appOptions" :key="key" :value="key" >
                  {{ value }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['column.jobNumber']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="user">
              <a-input v-model="model.user" :placeholder="language['common.pleaseInput']+language['column.jobNumber']"  :maxLength='30' ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['gift.user.id.card.number']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="idCardNumber">
              <a-input v-model="model.idCardNumber" :placeholder="language['common.pleaseInput']+language['gift.user.id.card.number']"  :maxLength='30' ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['portal.personalName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="name">
              <a-input v-model="model.name" :placeholder="language['common.pleaseInput']+language['portal.personalName']"  :maxLength='30' ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['gift.user.paying.legal.person']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="payingLegalPerson">
              <a-input v-model="model.payingLegalPerson" :placeholder="language['common.pleaseInput']+language['gift.user.paying.legal.person']" :maxLength='30'  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['depart.management.artificialPerson']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="company">
              <a-input v-model="model.company" :placeholder="language['common.pleaseInput']+language['depart.management.artificialPerson']" :maxLength='30'  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['gift_user_start_point']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="points">
              <a-input-number v-model="model.points" :placeholder="language['common.pleaseInput']+language['gift_user_start_point']" :min='1' :max='999999999' style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['gift_user_start_time']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="startTime">
              <a-date-picker value-format='YYYY-MM-DD HH:mm:ss' show-time :placeholder="language['column.pleaseChoose']+language['gift_user_start_time']" v-model="model.startTime" style="width: 100%"  />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['gift_user_deadline']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="endTime">
              <a-date-picker value-format='YYYY-MM-DD HH:mm:ss' show-time :placeholder="language['column.pleaseChoose']+language['gift_user_deadline']" v-model="model.endTime" style="width: 100%"  />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'AppUserForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      appOptions:[],
    },
    data () {
      const { language } = this.$store.getters;
      return language &&{
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
           app: [
              { required: true, message: language['common.pleaseChoose']+language['gift_app_no']},
           ],
          idCardNumber: [
              { required: true, message: language['common.pleaseInput']+language['portal.personalCardNo']},
            ],
           user: [
              { required: true, message: language['common.pleaseInput']+language['column.jobNumber']},
           ],
           name : [
              { required: true, message: language['common.pleaseInput']+language['portal.personalName']},
           ],
           payingLegalPerson: [
              { required: true, message: language['common.pleaseInput']+language['gift.user.paying.legal.person']},
           ],
           company: [
            { required: true, message: language['common.pleaseInput']+language['depart.management.artificialPerson']},
           ],
           points: [
              { required: true, message: language['common.pleaseInput']+language['gift_user_start_point']},
           ],
           endTime: [
              { required: true, message: language['common.pleaseInput']+language['gift_user_deadline']},
           ],
        },
        url: {
          add: "/gift/user/appuser",
          edit: "/gift/user/appuser",
          queryById: "/gift/user/appuser/"
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      language() {
        return this.$store.getters.language
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>
